import t from "components/i18n";

const greetingMessage = () => {
  return t('dashboard.title');
};

export default greetingMessage;
